var SCM = SCM || {};
SCM.ViewLarge = (function($) {

    return {
        registerMousePointer: registerMousePointer
    };

    function registerMousePointer() {
        var $contentImage = $('.widget-FigureViewLarge .content-image');
        if ($contentImage.length > 0) {

            $contentImage.on("load").each(function () {
                setMousePointer($(this));
            });

            $contentImage.mouseover(function () {
                setMousePointer($(this));
            });
            $contentImage.mouseout(function () {
                $(this).css('cursor', 'default');
            });
        }
    }

    function setMousePointer($imageElement) {
        var currentWidth = $imageElement.width();
        var currentHeight = $imageElement.height();
        var intrinsicWidth = $imageElement[0].naturalWidth;
        var intrinsicHeight = $imageElement[0].naturalHeight;

        if (intrinsicWidth > currentWidth && intrinsicHeight > currentHeight) {
            $imageElement.css('cursor', 'zoom-in');
        }
        else {
            $imageElement.css('cursor', 'pointer');
        }
    }
})(jQuery);